export const num2name = {
    0: "ERROR_UNSPECIFIED",
    1: "ERROR_NOT_FOUND",
    2: "ERROR_ALREADY_STARTED",
};
export const name2num = {
    ERROR_UNSPECIFIED: 0,
    ERROR_NOT_FOUND: 1,
    ERROR_ALREADY_STARTED: 2,
};
